import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/remediations',
        component: () => import('@/pages/remediations/RemediationIndex.vue'),
        props: true,
        children: [
            {
                name: 'remediations-index',
                path: '',
                component: () => import('@/components/remediation/RemediationsView.vue'),
                meta: {
                    title: 'Remediations',
                    middleware: [GateKeeperMiddleware],
                    ability: {
                        action: 'view all',
                        subject: 'remediation processes',
                    },
                    dataTablePage: true,
                },
                props: true,
            },
        ],
    },
];
